import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { SMS_Interface } from 'src/app/Interface/SMS_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SMSService {

  constructor(private http:HttpClient) { }


  GetRecord(id: number,
    Key: String,
    Token:String): Observable<Array<SMS_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/SMS?token=" + Token
      + "&key=" + Key
      + "&id="+id).pipe(
      map(data=>{
        return data as Array<SMS_Interface>
      })
    )
  }

  GetTitle(Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/SMS/GetTitle?token="+Token).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

}
